import { Axios } from 'utils'

export const sitesDetailsService = () => {
  const deleteSite = async (siteId: string) => {
    try {
      const response = await Axios.delete<{ status: boolean; detail: string }>(
        `/companies/${siteId}`
      )
      return response.data
    } catch (error: unknown) {
      throw error
    }
  }

  return {
    deleteSite,
  }
}
